import { mediaKindMarker } from '../utils/mediaKind';

/**
 * The `(YouTube)` / `(PDF)` marker rendered after a story title, styled like
 * the `is_gated` ($) marker. Renders nothing for rows without a `media_kind`.
 * The vocabulary and marker text live in `utils/mediaKind.ts`.
 */
export function MediaKindMarker({ kind }: { kind?: string | null }) {
  const marker = mediaKindMarker(kind);
  if (!marker) return null;
  return <span className="gated-marker" title={marker.title}> {marker.label}</span>;
}
